import * as React from "react";
import { ConfirmIcon } from "./ConfirmIcon";
import { Button, Card, Classes, Dialog, Intent } from "../../index";

export type ConfirmModalProps = {
    message: React.ReactNode;
    intent?: Intent;
    confirmButtonTitle?: string;
    cancelButtonTitle?: string;
    onConfirm: () => void;
    onCancel?: () => void;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
    message,
    intent,
    onConfirm,
    onCancel,
    confirmButtonTitle = "Ano",
    cancelButtonTitle = "Ne",
}) => {
    const handleOnCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    const handleOnConfirm = () => {
        onConfirm();
    };

    return (
        <Dialog onClose={handleOnCancel} isOpen isCloseButtonShown={false}>
            <div className={Classes.DIALOG_BODY}>
                <Card className={"bg-background-2 d-flex flex-column align-items-center"}>
                    <div>
                        <ConfirmIcon />
                    </div>
                    <div className={"modal-bigger-text mt-3"}>{message}</div>
                </Card>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button title={cancelButtonTitle} onClick={handleOnCancel} outlined fill className={"ml-0"}>
                        {cancelButtonTitle}
                    </Button>
                    <Button title={confirmButtonTitle} onClick={handleOnConfirm} intent={intent} fill>
                        {confirmButtonTitle}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
